<template>
    <div>
        <div class="col-12 pb-5 mb-4" v-if="contentloader">
            <img src="../../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
        </div>
        <div v-if="!contentloader">
            <div class="card" v-if="draftVideosList.length < 1">
                <div class="card-body text-center pt-5 pb-5">
                    <div class="p-5 d-flex flex-column text-center">
                        <img src="../../assets/no_video.svg" alt="novideo" class="img-md-fluid img-sm-fluid no-video pl-5 pr-5 pb-4">
                        <span class="proximanova-thin fontsize24 black60">You don't have any draft Videos</span>
                    </div>
                </div>
            </div>
            <div v-else>
                <div v-for="(videoitem, index) in draftVideosList" :key="index">
                    <div class="card pb-3 mb-3">
                        <div class="card-body postedvideoslist">
                            <div class="d-flex flex-column">
                                <div class="videocardhead d-flex justify-content-between p-3">
                                    <div class="d-flex">
                                        <div class="postvideoimage pl-1">
                                            <img v-if="profilePicLink" :src="profilePicLink" oncontextmenu="return false" alt="profilepic" class="rounded-circle border border-secondary loadingBgImg" width="40px">
                                            <img v-else  src="../../assets/Profile_placehlder.svg" width="38px" alt="profilpic">
                                        </div>
                                        <div class="d-flex flex-column pl-2 pr-2 mt-0">
                                            <span class="fontsize14 proximanova-semibold black">{{firstname}} {{lastname}}</span>
                                            <span class="proximanova black80 fontsize12">{{userdesignation}}-{{userCountry.countryName}}</span>
                                        </div>
                                        <div class="proximanova black80 fontsize12 pt-1 ml-3">
                                            <span v-if="videoitem.creationD !== null && videoitem.lastUpdatedD == null">{{new Date(videoitem.creationD) | moment("from", "now", true)}} ago</span>
                                            <span v-else>{{new Date(videoitem.lastUpdatedD) | moment("from", "now", true)}} ago</span>
                                        </div>
                                    </div>
                                    <div>
                                        <img src="../../assets/horizontal_menu_icon.svg" v-popover = "{name: videoitem.moremenuname}" :id="videoitem.moremenuname" width="20px" alt="moremenu" class="more_option moreactionsmenu">
                                        <popover v-bind:name="videoitem.moremenuname" class="postvideomenu" id="postvideomenu">
                                            <div class="p-3">
                                                <div class="d-flex p-1 justify-content-between">
                                                    <span class="fontsize12 proximanova-bold black">More Actions</span>
                                                    <div class="closebtn11">
                                                        <img src="../../assets/closebtn.svg" alt="close" class="img-fluid pr-1 closebtn1" @click="closePostMoreActions(videoitem.moremenuname)">
                                                    </div>
                                                </div>
                                                <div class="d-flex p-1 pl-2 ml-1 action" @click="EditPostedVideo(videoitem, videoitem.id, index)">
                                                    <img src="../../assets/Editvideo.svg" alt="edit" class="img-fluid">
                                                    <span class="p-2 fontsize14 black80 proximanova">Edit</span>
                                                </div>
                                                <div class="d-flex p-1 pl-2 ml-1 action" @click="clickOnDeleteDraftVideo(videoitem)">
                                                    <img src="../../assets/Deletevideo.svg" alt="delete" class="img-fluid">
                                                    <span class="p-2 fontsize14 black80 proximanova">Delete</span>
                                                </div>
                                            </div>
                                        </popover>
                                        <div class="modal backgroundnone fade confirmmodal" :id="'deletedraftVideoModal'+videoitem.id" tabindex="-1" role="dialog" aria-labelledby="deletedraftVideoModalLabel" aria-hidden="true">
                                            <div class="modal-dialog " role="document">
                                                <div class="modal-content pb-2">
                                                    <div class="modal-header delete-modal pb-0">
                                                        <h5 class="modal-title fontsize20 black80 proximanova" id="deletedraftVideoModalLabel">Are you sure you want to delete this record ?</h5>
                                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                        </button>
                                                    </div>
                                                    <div class="modal-body backgroundcolorwhite modal-delete text-center">
                                                        <span class="button-cancel-font modaldeletebtn pointer border borderradius20 p-2 pr-4 pl-4 proximanova" data-dismiss="modal" aria-label="Close" >No</span>
                                                        <span class="button-cancel-font backgroundcolorblack pointer white p-2 ml-2 pr-4 pl-4 borderradius20 proximanova"  @click="DeleteDraftVideo(videoitem.id, index)">Yes</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="videocardbody">
                                  <!-- <span v-if="videoitem.aspectRatio">
                                    <span v-if="videoitem.aspectRatio < 1">
                                      <video oncontextmenu="return false" controlsList="nodownload" controls muted preload="metadata" class="draftedvideoItem portraitvideheight" :id="'draftvideo'+index" webkit-playsinline playsinline>
                                        <source :src="videoitem.videoLink">
                                      </video>
                                    </span>
                                    <span v-if="videoitem.aspectRatio >= 1">
                                      <video oncontextmenu="return false" controlsList="nodownload" controls muted preload="metadata" class="draftedvideoItem" :id="'draftvideo'+index" webkit-playsinline playsinline>
                                        <source :src="videoitem.videoLink">
                                      </video>
                                    </span>
                                  </span>
                                  <span v-else> -->
                                    <video oncontextmenu="return false" height="430" controlsList="nodownload" controls muted preload="metadata" class="draftedvideoItem" :id="'draftvideo'+index" webkit-playsinline playsinline>
                                      <source :src="videoitem.videoLink">
                                    </video>
                                  <!-- </span> -->
                                </div>
                                <div class="postvideocontent p-1 pb-2 pl-3">
                                  <div class="d-flex flex-column pl-2">
                                    <span class="proximanova-semibold fontsize16 black80">{{videoitem.videoTitle}}</span>
                                    <span class="proximanova fontsize14">{{videoitem.videoDescription}}</span>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <updatepostmodal v-if="updatepostvideomodal" :updatevideomyvidsection="updatingVideoObj" @close= "closeupdatepostmodal"></updatepostmodal>
        <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal>
    </div>
</template>
<script>
import httpuserprofile from "@/js/http-userprofile.js";
import updatepostmodal from '../updatePostVideoModal.vue'
import APIerrorModal from '../APIerrorpopup.vue'
import $ from 'jquery'
export default {
    props : ['userProfileDetails'],
    components: {
        updatepostmodal,
        APIerrorModal
    },
    data() {
        return {
            contentloader : true,
            displayAPIerrorModal : false,
            profileId : '',
            profilePicLink:'',
            firstname : '',
            lastname : '',
            userCountry : null,
            userdesignation : '',
            draftVideosList : [],
            //update video
            updatepostvideomodal : false,
            updatingVideoObj : {},
            selectedDraftVideoIndex : null,
        }
    },
    mounted() {
        this.profileId = this.userProfileDetails.profileId;
        this.setData()
        this.getDraftVideos()
    },
    methods : {
        setData : function() {
            this.profilePicLink = this.userProfileDetails.profilePictureLink;
            this.firstname = this.userProfileDetails.firstName;
            this.lastname = this.userProfileDetails.lastName;
            if(this.userProfileDetails.designation){
                this.userdesignation = this.userProfileDetails.designation.roleName
            }
            this.userCountry = this.userProfileDetails.country
        },
        closeAPIerrorModal(){
            this.displayAPIerrorModal = false;
        },
        getDraftVideos : function() {
            this.draftVideosList = []
            httpuserprofile.get("/userprofile/getdraftVideosList?profileId="+this.profileId)
            .then((response) => {
                this.contentloader = false;
                response.data.forEach(function(d){
                d.isPlaying = false;
                d.isMuted = false;
                d.moremenuname = 'popover'+d.id;
                setInterval(function(){
                    const $video = document.createElement("video");
                    $video.src = d.videoLink;
                    $video.addEventListener("loadedmetadata", function () {
                    if(this.videoWidth) {
                        d.videoWidth =  this.videoWidth
                    }else{
                        d.videoWidth =  null;
                    }if(this.videoHeight){
                        d.videoHeight = this.videoHeight
                    }else{
                        d.videoHeight = null
                    }
                    d.aspectRatio = this.videoWidth/this.videoHeight;
                    this.contentloader = false;
                    });
                }, 3000)
                })
                this.draftVideosList = response.data;
                console.log("draft videos list : ", this.draftVideosList)
            }).catch((e) => {
                console.log(e)
                this.contentloader = false;
            })
        },
        //this will invoke after click on edit option on moremenu popover to edit a draft video
        EditPostedVideo : function(obj, videoId, index) {
            console.log("edit button clicked on posted videoItem : ", videoId)
            console.log("editing obj : ", obj)
            this.updatepostvideomodal = true;
            this.updatingVideoObj = obj;
            if(obj.videoType === 'DRAFT'){
                this.selectedDraftVideoIndex = index
            }
        },
        clickOnDeleteDraftVideo(videoitem) {
            var id = "#deletedraftVideoModal"+videoitem.id
            $(id).modal('show')
        },
        //this will invoke after click on delete option on moremenu popover to delete a draft video
        DeleteDraftVideo : function(videoId, index) {
            console.log("video id : ", videoId, index)
            var vm = this
            // httpuserprofile.delete('/userprofile/deleteVideo?profileId='+this.profileId+'&videoId='+videoId)
            httpuserprofile.delete('/userprofile/deletePostedVideo?videoId='+videoId)
            .then((response) => {
                console.log(response)
                var id = "#deletedraftVideoModal"+videoId
                $(id).modal('hide')
                this.closePostMoreActions(this.draftVideosList[index].moremenuname)
                vm.$toast.success("Successfully deleted draft video")
                this.draftVideosList.splice(index, 1)
                this.draftVideosList.forEach((video,index) =>{
                video.moremenuname = 'popover'+index;
                })
            }).catch((e) => {
                console.log(e)
                var id = "#deletedraftVideoModal"+videoId
                $(id).modal('hide')
                this.displayAPIerrorModal = true;
            })
        },
        closePostMoreActions : function(id) {
            document.getElementById(id).click()
        },
        //this will invoke after click on cancel button on update video modal
        closeupdatepostmodal(returnObj) {
            this.updatepostvideomodal = false;
            console.log("close modal", returnObj)
            if(returnObj.videoOriginalType === 'DRAFT' && returnObj.type === 'SUCCESS' && returnObj.videoType === 'POST'){
                this.draftVideosList.splice(this.selectedDraftVideoIndex, 1)
                this.draftVideosList.forEach((video,index) =>{
                    video.moremenuname = 'popover'+index;
                })
            }
        },
    }
}
</script>
<style scoped>
.closebtn1{
  cursor: pointer;
  width: 15px;
  height: 15px;
  margin-top: -3px;
}
.closebtn11:hover{
  background-color: rgba(161, 166, 179,0.3);
  padding-left: 2px;
  border-radius: 50%;
}
.more_option {
  cursor: pointer;
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.portraitvideheight{
  height: 500px;
}
.modal-height{
  height: auto;
  margin-top: 5% !important;
  width: 100% !important;
  border-radius: 10px !important;
}

.modal-body{
  background-color: #000000
}
.modal{
  background-color: rgba(31,31,31,.89);
}
#vid {
  width: 100%;
  /* margin-left: .20%; */
}
.pageloader {
  width: 7%;
  margin-top: 15%;
  margin-left: 46%;
}
.moreactionsmenu {
  width: 25px;
  padding: 3px;
  border: 1px solid white;
}
.moreactionsmenu:hover{
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 50%;
  border: 1px solid rgba(161, 166, 179,.5);
}
/* Notification Actions */
  .dropdown-position-bottom.postvideomenu {
    z-index: 3 !important;
    color: rgba(31,31,31,1)  !important;
    font-size: 12px !important;
    top: 50px !important;
    font-weight: 500;
    width: 150px !important;
    left: 79% !important;
  }
  .vue-popover.dropdown-position-bottom.postvideomenu:before {
    display: none !important;
  }

.line {
  display: block;
  height: 1px;
  border: 0;
  padding: 0;
  border: 1px solid #1f1f1f;
  opacity: 0.1;
}
.action {
  cursor: pointer;
}
.action:hover {
  background-color:rgba(221, 223, 229,0.4);
  border-radius: 5px;
}
.button {
  color: #1f1f1f !important;
}
.close{
  padding: 1px 7px 5px 7px !important;
  /* margin-top: 0px !important; */
  margin-top: -3px !important;
  margin-right: 5px !important;
}
.close:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.postedvideoslist{
  padding: 0 !important;
}
.videocardbody {
    position: relative;
    width: 100%;
    height: 100%;
    /* //padding: 20px; */
    background-attachment: scroll;
    overflow: hidden;
    background: black;
}
.videocardbody video {
    min-width: 100%;
    min-height: 100%;
    width: 100%;
    position: relative;
    z-index: 1;
    margin-bottom: -1%;
}
.videocardbody .overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    margin-top: 0px !important;
    z-index: 2;
    background: rgba(31, 31, 31, .6);
    /* background: linear-gradient(0deg, rgba(0,0,0,0) 0%, #000000 100%); */
    /* background: linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 50%); */
    opacity: 0.5;
    /* margin-top: -5px; */
}
.btn:focus {
  outline: none;
  box-shadow: none;
}
.loadingBgImg{
  background: transparent url('../../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
video::-webkit-media-controls-fullscreen-button {
    display: none;
}
.confirmmodal{
  margin-top: 15%;
}
.delete-modal{
  border: none;
}
.modaldeletebtn{
  transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
}
.modaldeletebtn::before{
  transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
  margin-top: -1px;
	background-color :  rgba(29, 27, 27, 0.1);
}
.modaldeletebtn:hover::before{
  transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
@media only screen and (max-width: 600px) {
  .videocardbody video{
    width: 100% !important;
  }
  .pageloader {
    width: 20%;
    margin-top: 25%;
    margin-left: 40%;
  }
}
@media screen and (min-width: 600px) {
  .no-video {
    width: 50%;
    align-self: center;
  }
}
@media screen and (max-width: 600px) and (min-width: 539px) {
  .dropdown-position-bottom.postvideomenu {
    left: 70% !important;
  }
}
@media screen and (max-width: 539px) and (min-width: 400px) {
  .dropdown-position-bottom.postvideomenu {
    left: 60% !important;
  }
}
@media screen and (max-width: 400px) and (min-width: 350px) {
  .dropdown-position-bottom.postvideomenu {
    left: 55% !important;
  }
}
@media screen and (max-width: 350px) and (min-width: 300px) {
  .dropdown-position-bottom.postvideomenu {
    left: 50% !important;
  }
}
@media screen and (max-width: 300px) {
  .dropdown-position-bottom.postvideomenu {
    left: 40% !important;
  }
}
</style>